import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ResponsiveGrid from './components/ResponsiveGrid';
import ResponsiveHeader from './components/ResponsiveHeader';
import './App.css';
import  Page1  from './pages/Page1';
import  Page2  from './pages/Page2';
import  Page3  from './pages/Page3';
import  Page4  from './pages/Page4';
import  Page5  from './pages/Page5';
import  Page6  from './pages/Page6';
import  Page7  from './pages/Page7';
import  Page8  from './pages/Page8';
import Pg404 from './pages/Pg404';



const App: React.FC = () => {
  return (
    <Router>
      {/* OLD HIDDEN navbar FOR NOW TOP NAVBAR */}
      {/* <div>
        <Link to="/pages/1">1</Link>
         <Link to="/pages/2">2</Link>
          <Link to="/pages/3">3</Link>
           <Link to="/pages/4">4</Link>
            <Link to="/pages/5">5</Link>
             <Link to="/pages/6">6</Link>
              <Link to="/pages/7">7</Link>
               <Link to="/pages/8">8</Link>
                </div> */}
    <Routes>
        <Route
          path="/"
          element={
            <>
            <ResponsiveHeader />
            <ResponsiveGrid />
            </>
          }
        />
    <Route path="/pages/1" element={<Page1/>} />
    <Route path="/pages/2" element={<Page2/>} />
    <Route path="/pages/3" element={<Page3/>} />
    <Route path="/pages/4" element={<Page4/>} />
    <Route path="/pages/5" element={<Page5/>} />
    <Route path="/pages/6" element={<Page6/>} />
    <Route path="/pages/7" element={<Page7/>} />
    <Route path="/pages/8" element={<Page8/>} />
    <Route path="*" element={<Pg404/>} />  
    </Routes>
    </Router>
  );
};


export default App;  